import React from "react";
import { makeStyles, Link as MuiLink } from "@material-ui/core";
import Link from "next/link";
import LogoMurphy from "components/header/assets/logo-murfy.svg";

export default function FunnelTopHeader({ children, cta, logoHref }) {
  const classes = useStyle();
  return (
    <div className={classes.topHeader}>
      <div className={classes.topBar}>
        <a href={logoHref || "/reconditionne"} className={classes.homeIcon}>
          <LogoMurphy className={classes.logo} />
        </a>
        <div className={classes.navContainer}>{children}</div>
        {cta ? (
          React.cloneElement(cta, { className: classes.continueBuy })
        ) : (
          <Link href="/reconditionne" passHref>
            <MuiLink className={classes.continueBuy}>Continuer mes achats</MuiLink>
          </Link>
        )}
      </div>
    </div>
  );
}

const useStyle = makeStyles((theme) => ({
  topHeader: {
    position: "relative",
    zIndex: 3,
  },
  continueBuy: {
    textDecoration: "none",
    marginLeft: "auto",
    color: theme.palette.secondary.main,
  },
  topBar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    background: theme.palette.primary.main,
    paddingTop: theme.spacing(),
    paddingBottom: theme.spacing(),
    paddingLeft: theme.spacing(5),
    paddingRight: theme.spacing(5),
  },
  navContainer: {
    display: "flex",
    alignItems: "center",
    position: "absolute",
    boxSizing: "border-box",
    left: "max(50px , calc(100vw - 1120px)/2)",
    "& >*": {
      marginLeft: theme.spacing(2),
      marginRight: theme.spacing(2),
    },
  },
  homeIcon: {
    cursor: "pointer",
    marginRight: theme.spacing(2),
    "&:hover": {
      opacity: 0.7,
    },
  },
  logo: {
    fill: theme.palette.secondary.main,
    width: 60,
    height: 60,
  },
}));
